<template>
  <div id="app">
    <router-view v-wechat-title="documentTitle"/>
  </div>
</template>

<script>
import {mixins} from "./utils/mixins";

export default {
  mixins:[mixins],
  name: 'App',
  computed:{
    documentTitle(){
      return  this.languageId===1
        ? this.$route.meta.title
        :this.$route.meta.enTitle
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/App.vue